//Character Selection scene
import common from "../common";
import { translate } from "../utils";
import Scene from "./Scene";

export default class CharacterSelectScene extends Scene {
    constructor() {
        super();

        super.init();

        this._bg = new PIXI.Sprite(P3.assets.texture('bg_main'));
        // bg.anchor.set(0.5);
        //  bg.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this._bg.width = common.STAGE_WIDTH;
        this._bg.height = common.STAGE_HEIGHT;
        this.addChild(this._bg);

        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_primary_small_out');
        states.over = P3.assets.texture('btn_primary_small_over');
        states.down = P3.assets.texture('btn_primary_small_down');
        states.icon = P3.assets.texture('icon_sound_on');
        states.iconAlt = P3.assets.texture('icon_sound_off');

        this._muteButton = new P3.MuteButton(states);
        this._muteButton.signals.up.add(function () {
            common.saveData.data.mute = !P3.audio.isMuted();
            common.saveData.save();
        }, this);
        this.addChild(this._muteButton);

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_primary_small_out');
        states.over = P3.assets.texture('btn_primary_small_over');
        states.down = P3.assets.texture('btn_primary_small_down');
        states.icon = P3.assets.texture('icon_back');
        this._backButton = new P3.Button(states);
        this._backButton.signals.click.add(this.onBackButtonClick, this);
        this.addChild(this._backButton);

        this._labelPanelA = new PIXI.Sprite(P3.assets.texture("title_1_bg"));
        this._labelPanelA.anchor.set(0.5);
        this.addChild(this._labelPanelA);
        this._labelA = new PIXI.Text(translate("character_elliot"), { //TODO no translations yet
            fontFamily: "Fred Fredburger",
            fontSize: 58,
            dropShadow: true,
            dropShadowAngle: 2.5,
            dropShadowColor: "#fe2e8b",
            fill: "#ffffff",
            padding: 5
        });
        this._labelA.anchor.set(0.5);
        this.addChild(this._labelA);

        //Character selection icons
        this._characterSelectContainer = new PIXI.Container();
        this.addChild(this._characterSelectContainer);
        this._characterSelectIcons = [];

        const json = P3.assets.json("characters");
        for (let i=0; i<json.length; i++) {
            this.createCharacterSelectIcon(json[i], i);
        }
        this._json = json;

        common.lastCharacterPlayed = common.saveData.data.lastCharacterPlayed || 0;
        this._charId = 3;
        this.updateCharacterSelectIcons(this._charId);
        this._charLookId = this._charId;
        this._charLookTime = 0;
        this._charLookMaxTime = 0.4;
        this._charLookDirection = 0;
        this._lastCharId = this._charId;
        this._charTweenNo = 0;

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_right');
        states.over = P3.assets.texture('btn_right');
        states.down = P3.assets.texture('btn_right');
        this._buttonNext = new P3.Button(states);
        this._buttonNext.scale.set(0.5);
        this._buttonNext.signals.click.add(this.selectNextCharacter, this);
        this.addChild(this._buttonNext);

        states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_left');
        states.over = P3.assets.texture('btn_left');
        states.down = P3.assets.texture('btn_left');
        this._buttonPrevious = new P3.Button(states);
        this._buttonPrevious.scale.set(0.5);
        this._buttonPrevious.signals.click.add(this.selectPreviousCharacter, this);
        this.addChild(this._buttonPrevious);

        //Play button
        states = new P3.ButtonStates();
        states.normal = P3.assets.texture('btn_secondary_out');
        states.over = P3.assets.texture('btn_secondary_over');
        states.down = P3.assets.texture('btn_secondary_down');
        states.icon = P3.assets.texture('icon_play_small');

        this._playButton = new P3.Button(states);
        this._playButton.signals.click.add(this.onPlayButtonClick, this);
        this.addChild(this._playButton);

        //Scale (smaller on small views)
        this._iconScale = Math.min(1, P3.View.width/1218);
        this._iconSeparation = 303;
        this._noOfIcons = this._characterSelectIcons.length;
        this._iconDepthDivide = Math.max(1, 2-(this._noOfIcons-3)/4);
        if (this._noOfIcons === 4)
            this._iconDepthDivide = 1;

        //Dragging
        this._isDragging = 0;
        this._dragStartTime = 0;
        this._dragDistance = 0;
        this._dragThreshold = 100;
        this._dragMaxTime = 100;
        this._dragStartX = 0;

        P3.input.signals.mouseDown.add((event)=>{this.onDragStart(event)});
        P3.input.signals.mouseUp.add((event)=>{this.onDragEnd(event)});
        P3.input.signals.mouseMove.add((event)=>{this.onDragMove(event)});
    }

    updateCharacterSelectIcons(n) {
        for (let i=0; i<this._noOfIcons; i++) {
            const icon = this._characterSelectIcons[i];
            icon.depth = this.getDepth(icon.id, n, this._noOfIcons)/(this._noOfIcons/2)/(this._iconDepthDivide);
            icon.scale.set((1-Math.abs(icon.depth)/5)*this._iconScale);

            const d1 = this.getDepth(0, 1, this._noOfIcons)/this._noOfIcons*2;

            icon.x = common.STAGE_WIDTH/2+Math.sin(icon.depth*Math.PI*2*d1)*this._iconSeparation*this._iconScale;

            //icon.visible = this._characterSelectContainer.children.indexOf(icon) > this._noOfIcons-4;
        }

        this._characterSelectContainer.children.sort((a, b)=>{
            return (Math.abs(b.depth)-Math.abs(a.depth));
        });

        this._labelA.text = translate("character_" + this._json[this._charId].name);

    }

    getDepth(a, b, size) {
        return ((a-b+3*size/2)%size)-size/2;
    }


    createCharacterSelectIcon(data, id) {
        const sprite = new PIXI.Sprite(P3.assets.texture(data.draw_icon));
        sprite.id = id;
        sprite.anchor.set(0.5);
        sprite.position.set(common.STAGE_WIDTH/2, common.STAGE_HEIGHT/2);
        this._characterSelectContainer.addChild(sprite);
        this._characterSelectIcons.push(sprite);

        if (data.name === "sunblast" || data.name === "penumbra" || data.name === "missheed") {
            if (!common.saveData.data.charactersPlayed[id]) 
            {
                const badge = new PIXI.Sprite(P3.assets.texture("new"));
                badge.anchor.set(0.5);
                badge.position.set(sprite.width/2-30, -sprite.height/2+30);
                badge.rotation = 0.21;
                sprite.addChild(badge);
            }
        }

    }

    selectPreviousCharacter() {
        this._lastCharId = this._charId;
        this._charLookId = this._lastCharId;
        this._charId = (this._charId + 1) % this._noOfIcons;
        this._charLookDirection = 1;
        this._charLookTime = 0;
        this._labelA.text = translate(this._json[this._charId].name);
    }

    selectNextCharacter() {
        this._lastCharId = this._charId;
        this._charLookId = this._lastCharId;
        this._charId = (this._charId + this._noOfIcons - 1) % this._noOfIcons;
        this._charLookDirection = -1;
        this._charLookTime = 0;
        this._labelA.text = translate(this._json[this._charId].name);
    }

    update() {
        super.update();
        this.updateCharacterSelectIcons(this._charLookId);

        if (this._charLookDirection !== 0) {
            this._charLookTime += deltaTime/this._charLookMaxTime;
            const val = P3.utils.TWEEN.Easing.Quadratic.InOut(this._charLookTime)*this._charLookDirection;
            this._labelA.y = this._labelPanelA.y-Math.abs(Math.sin(val*Math.PI))*40;
            this._charLookId = (this._lastCharId+val+this._noOfIcons)%this._noOfIcons;

            if (this._charLookTime >= 1) {
                this._charLookDirection = 0;
                this._charLookId = this._charId;
            }
        }
    }

    resize() {
        super.resize();
        this._iconScale = Math.min(1, P3.View.width/1218);
        this._muteButton.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 100, 100);
        this._backButton.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 220, 100);
        this._playButton.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT/2+195*this._iconScale);

        this._labelPanelA.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5 - 205);
        this._labelA.position = this._labelPanelA.position.clone();

        this._buttonNext.position.set(common.STAGE_WIDTH/2+500*this._iconScale, common.STAGE_HEIGHT/2);
        this._buttonPrevious.position.set(common.STAGE_WIDTH/2-500*this._iconScale, common.STAGE_HEIGHT/2);
    }

    onPlayButtonClick() {
        common.saveData.data.lastCharacterPlayed = this._charId;
        common.saveData.save();
        common.saveData.data.charactersPlayed[this._charId] = true;
        this.signals.next.dispatch(this._charId);
    }

    onBackButtonClick() {
        common.saveData.data.lastCharacterPlayed = this._charId;
        common.saveData.save();
        this.signals.previous.dispatch(this);
    }

    //Dragging
    onDragStart(event) {
        this._isDragging = true;
        this._dragStartTime = window.performance.now();
        this._dragStartX = event.data.global.x;
    }

    onDragEnd() {
        this._isDragging = false;
        this._dragDistance = 0;
    }

    onDragMove(event) {
        const dragTime = window.performance.now()-this._dragStartTime;
        if (this._isDragging && dragTime < this._dragMaxTime) {
            const x = event.data.global.x;
            if (x > this._dragStartX + this._dragThreshold) {
                this.onDragEnd();
                this.selectPreviousCharacter();
            }
            else if (x < this._dragStartX - this._dragThreshold) {
                this.onDragEnd();
                this.selectNextCharacter();
            }

        }
    }
}
